addExportedVariables